import { useEffect, useState } from 'react'

import { normalizeSplitPercent } from '@/components/pos/posCart'
import { Button } from '@/components/ui/button'

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {import('@/types/api').SaleLine | null} props.line
 * @param {import('@/types/api').Stylist[]} props.stylists
 * @param {boolean} props.disabled
 * @param {boolean} [props.focusSplit]
 * @param {(lineId: number, stylistId: number | null, splitPercent: number) => void} props.onAssign
 */
export function PosLineStylistModal({
  open,
  onClose,
  line,
  stylists,
  disabled,
  focusSplit = false,
  onAssign,
}) {
  const [stylistId, setStylistId] = useState('')
  const [splitPercent, setSplitPercent] = useState(100)

  useEffect(() => {
    if (!line || !open) return
    setStylistId(line.stylist_id ? String(line.stylist_id) : '')
    setSplitPercent(normalizeSplitPercent(line.stylist_split_percent ?? 100))
  }, [line, open])

  if (!open || !line) return null

  function handleApply() {
    const nextStylistId = stylistId ? Number(stylistId) : null
    onAssign(line.id, nextStylistId, splitPercent)
    onClose()
  }

  return (
    <div
      className="pos-v2-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Assign stylist"
      onClick={disabled ? undefined : onClose}
    >
      <div
        className="w-full max-w-sm rounded-lg border bg-white p-4 shadow-xl"
        onClick={(event) => event.stopPropagation()}
      >
        <p className="text-sm font-bold text-slate-900">{line.description}</p>
        <p className="mb-3 text-xs text-slate-500">Assign stylist and commission split</p>

        <label className="mb-3 block space-y-1">
          <span className="text-[10px] font-bold uppercase text-slate-500">Stylist</span>
          <select
            value={stylistId}
            disabled={disabled}
            autoFocus={!focusSplit}
            onChange={(event) => setStylistId(event.target.value)}
            className="h-11 w-full rounded-md border border-input bg-white px-3 text-sm"
          >
            <option value="">Unassigned</option>
            {stylists.map((stylist) => (
              <option key={stylist.id} value={stylist.id}>
                {stylist.name}
              </option>
            ))}
          </select>
        </label>

        <label className="mb-4 block space-y-1">
          <span className="text-[10px] font-bold uppercase text-slate-500">Split %</span>
          <input
            type="number"
            min="0"
            max="100"
            step="5"
            value={splitPercent}
            disabled={disabled || !stylistId}
            autoFocus={focusSplit}
            onChange={(event) => setSplitPercent(normalizeSplitPercent(event.target.value))}
            className="h-11 w-full rounded-md border border-input bg-white px-3 font-mono text-sm"
          />
        </label>

        <div className="flex gap-2">
          <Button type="button" variant="outline" className="flex-1" disabled={disabled} onClick={onClose}>
            Cancel
          </Button>
          <Button type="button" className="flex-1" disabled={disabled} onClick={handleApply}>
            Apply
          </Button>
        </div>
      </div>
    </div>
  )
}
